
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import { DxCheckBox } from "devextreme-vue/check-box";
import TextControl from "@/components/controls/base/TextControl.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    CreateEditDialog,
    TextControl,
    DxCheckBox,
    IntegerControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  watch: {},
  methods: {
    onIsBooleanTrueAnyNotEmptyValueChanged(value: any) {
      if (value) {
        this.createEditModel.booleanTrueValue = "";
      }
    },
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
  },
  data() {
    return {};
  },
});
